import pkgJson from '../package.json';
export * from './generator';
export * from './parse-page';

console.info('converter version: ', pkgJson.version);